import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { filterNulls } from 'src/utils/array';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import { FAQItem } from '../FAQItem';
import * as msgsData from './messages';

const { msgs, ...localesWithMessages } = msgsData;

type Props = {
  skipCoreLoop?: boolean;
};

export const FAQLanguageList = ({ skipCoreLoop }: Props) => {
  const intl = useIntl();

  const targetMsgs = useTargetMessages(localesWithMessages);

  const questions = useMemo(
    () =>
      filterNulls([
        targetMsgs.whyLearnQuestion && targetMsgs.whyLearnAnswer
          ? {
              question: intl.formatMessage(targetMsgs.whyLearnQuestion),
              answer: intl.formatMessage(targetMsgs.whyLearnAnswer),
            }
          : null,
        !skipCoreLoop
          ? {
              question: intl.formatMessage(targetMsgs.learnWithMemriseQuestion),
              answer: (
                <>
                  {intl.formatMessage(targetMsgs.learnWithMemriseAnswerPart1)}
                  <br />
                  <br />
                  {intl.formatMessage(targetMsgs.learnWithMemriseAnswerPart2)}
                  <br />
                  <br />
                  {'- '}
                  {intl.formatMessage(targetMsgs.learnWithMemriseAnswerPart3)}
                  <br />
                  {'- '}
                  {intl.formatMessage(msgs.learnWithMemriseAnswerPart4)}
                  <br />
                  {'- '}
                  {intl.formatMessage(msgs.learnWithMemriseAnswerPart5)}
                </>
              ),
            }
          : null,
        {
          question: intl.formatMessage(targetMsgs.whereStartQuestion),
          answer: (
            <>
              {intl.formatMessage(msgs.whereStartAnswerPart1)}{' '}
              {intl.formatMessage(targetMsgs.whereStartAnswerPart2)}
              <br />
              <br />
              {intl.formatMessage(targetMsgs.whereStartAnswerPart3)}
              {!skipCoreLoop && (
                <>
                  <br />
                  <br />
                  {intl.formatMessage(targetMsgs.whereStartAnswerPart4)}{' '}
                  {intl.formatMessage(targetMsgs.whereStartAnswerPart5)}{' '}
                  {intl.formatMessage(msgs.whereStartAnswerPart6)}
                  <br />
                  <br />
                  {intl.formatMessage(msgs.whereStartAnswerPart7)}{' '}
                  {intl.formatMessage(targetMsgs.whereStartAnswerPart8)}{' '}
                  {intl.formatMessage(msgs.whereStartAnswerPart9)}
                </>
              )}
            </>
          ),
        },
        {
          question: intl.formatMessage(targetMsgs.myLevelQuestion),
          answer: (
            <>
              {intl.formatMessage(msgs.myLevelAnswerPart1)}{' '}
              {intl.formatMessage(msgs.myLevelAnswerPart2)}
              {!skipCoreLoop && (
                <>
                  <br />
                  <br />
                  {intl.formatMessage(msgs.myLevelAnswerPart3)}
                </>
              )}
              <br />
              <br />
              {intl.formatMessage(msgs.myLevelAnswerPart4)}
              <br />
              <br />
              {intl.formatMessage(msgs.myLevelAnswerPart5)}
            </>
          ),
        },
        {
          question: intl.formatMessage(targetMsgs.howMuchTimeQuestion),
          answer: (
            <>
              {intl.formatMessage(msgs.howMuchTimeAnswerPart1)}
              <br />
              <br />
              {intl.formatMessage(msgs.howMuchTimeAnswerPart2)}{' '}
              {intl.formatMessage(msgs.howMuchTimeAnswerPart3)}
            </>
          ),
        },
        {
          question: intl.formatMessage(targetMsgs.certificateQuestion),
          answer: (
            <>
              {intl.formatMessage(msgs.certificateAnswerPart1)}
              <br />
              <br />
              {intl.formatMessage(msgs.certificateAnswerPart2)}
            </>
          ),
        },
        {
          question: intl.formatMessage(targetMsgs.difficultToLearnQuestion),
          answer: (
            <>
              {intl.formatMessage(msgs.difficultToLearnAnswerPart1)}{' '}
              {intl.formatMessage(msgs.difficultToLearnAnswerPart2)}
              <br />
              <br />
              {intl.formatMessage(targetMsgs.difficultToLearnAnswerPart3)}
            </>
          ),
        },
      ]),
    [targetMsgs, intl, skipCoreLoop],
  );

  return (
    <>
      {questions.map(({ question, answer }) => (
        <FAQItem key={question} question={question} answer={answer} />
      ))}
    </>
  );
};
